export default {"src":"/_next/static/media/linkedin_black.e2b27512.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};